import Config from "../../../Config";

/*

    0 - ID does not exist in the database
    1 - Trial
    2 - End of Trial
    3 - Licensed
    4 - End of License

*/ 
const checkLicense = async (aData,setLicense) =>
{
    const
    {
        startDate,
        endDate,
        license
    } = aData;

    if (!license.type)
    {
        return 0;
    }

    const fetchCurrentDate = async () =>
    {
        const response = await fetch(Config.env.ENGINE_URL.concat('/date'));
        const data = await response.json();
        return new Date(data.today);
    };

    const calculateDaysDifference = async (targetDateString) =>
    {
        const targetDate = new Date(targetDateString);
        const currentDate = await fetchCurrentDate();
        const timeDifference = targetDate - currentDate;
        return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    };

    if (license.type === "trial")
    {
        const daysDifference = await calculateDaysDifference(endDate);
        setLicense(prev => ({
            ...prev,
            daysLeft: daysDifference
        }));
        return daysDifference > 0 ? 1 : 2;
    }

    if (license.type === "licensed")
    {
        const daysDifference = await calculateDaysDifference(endDate);
        console.log(`Licensed: ${endDate}`);
        return daysDifference <= 0 ? 4 : 3;
    }
};

export default checkLicense;